import { render, staticRenderFns } from "./blog_info.vue?vue&type=template&id=fdf430ca&scoped=true&"
import script from "./blog_info.vue?vue&type=script&lang=js&"
export * from "./blog_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf430ca",
  null
  
)

export default component.exports